import { post } from '../index';

export const createUser = data => {
  return post('/users/registration', data);
};
